import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  formCierreCuentas: ["payload"],
  formCierreCuentasLoading: null,
  formCierreCuentasSuccess: ["formCierreCuentasData"],

  formConsultaCierresCuentas: ["payload"],
  formConsultaCierresCuentasLoading: null,
  formConsultaCierresCuentasSuccess: ["formConsultaCierresCuentasData"],

  consultarIngreso: ["payload"],
  consultarIngresoLoading: null,

  consultarDetalleCierreCuenta: ["payload"],
  consultarDetalleCierreCuentaLoading: null,

  getProcedimientosPermitidosCierreCuentas: ["payload"],
  getProcedimientosPermitidosCierreCuentasLoading: null,

  validarProcedimientoCierreCuentas: ["payload"],
  validarProcedimientoCierreCuentasLoading: null,

  eliminarProcedimientoCierreCuentas: ["payload"],
  eliminarProcedimientoCierreCuentasLoading: null,

  consultarReclamantes: ["payload"],
  consultarReclamantesLoading: null,

  cerrarCuentaClinica: ["payload"],
  cerrarCuentaClinicaLoading: null,

  consultarCierresCuentas: ["payload"],
  consultarCierresCuentasLoading: null,

  calcularOxigeno: ["payload"],
  calcularOxigenoLoading: null,

  consultarPacientesIngresados: ["payload"],
  consultarPacientesIngresadosLoading: null,

  formPacientesIngresados: ["payload"],
  formPacientesIngresadosSuccess: ["formPacientesIngresadosData"],

  formHojaQuirurgica: ["payload"],
  formHojaQuirurgicaSuccess: ["formHojaQuirurgicaData"],

  obtenerCamposHojaQuirurgica: ["payload"],
  obtenerCamposHojaQuirurgicaLoading: null,
  obtenerCamposHojaQuirurgicaSuccess: ["camposHojaQuirurgicaData"],
  obtenerCamposHojaQuirurgicaFailure: ["camposHojaQuirurgicaError"],

  crearSolicitudHojaQuirurgica: ["payload"],
  crearSolicitudHojaQuirurgicaLoading: null,
  crearSolicitudHojaQuirurgicaSuccess: ["crearSolicitudHojaQuirurgicaData"],
  crearSolicitudHojaQuirurgicaFailure: ["crearSolicitudHojaQuirurgicaError"],

  buscarSolicitudesHojaQuirurgica: ["payload"],
  buscarSolicitudesHojaQuirurgicaLoading: null,

  formSolicitudesHojaQuirurgica: ["payload"],
  formSolicitudesHojaQuirurgicaSuccess: ["formSolicitudesHojaQuirurgicaData"],

  obtenerDetalleSolicitudHojaQuirurgica: ["payload"],
  obtenerDetalleSolicitudHojaQuirurgicaLoading: null,
  obtenerDetalleSolicitudHojaQuirurgicaSuccess: ["detalleSolicitudHojaQuirurgicaData"],
  obtenerDetalleSolicitudHojaQuirurgicaFailure: ["detalleSolicitudHojaQuirurgicaError"],
  limpiarDetalleSolicitudHojaQuirurgica: null,
  limpiarFormHojaQuirurgica: null,
});

export { Types };

export default Creators;
